import React, { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import defaultBanner from "../../../assets/images/bg/default-banner.jpg";
import CandidateSideBar from "./CandidateSideBar";

export const CandidateLayout = (props) => {
  const [pathName, setPathName] = useState("");
  useEffect(() => {
    setPathName(window.location.pathname);
  }, []);

  return (
    <>
      {pathName.toLowerCase().includes("/candidates/previewresumetemplate") ? (
        <React.Fragment>{props.children}</React.Fragment>
      ) : (
        <>
          <Header candidateLayoutLoaded={true} />
          <React.Fragment>
            <div
              className="header-inner"
              style={{
                background: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${defaultBanner})`,
              }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <h2 style={{ color: "white" }}>Profil</h2>
                    <ol className="breadcrumb mb-0 p-0">
                      <li className="breadcrumb-item">
                        <a href="/"> Accueil </a>
                      </li>
                      <li className="breadcrumb-item">
                        <i className="fas fa-chevron-right"></i>
                        <a href="javascript:void(0)"> Candidat </a>
                      </li>
                      <li className="breadcrumb-item active">
                        {" "}
                        <i className="fas fa-chevron-right"></i>{" "}
                        <span> Profil </span>
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            {/* Candidate section */}
            <section className="space-ptb" style={{ padding: "50px 0" }}>
              <div className="container">
                <div className="row">
                  <CandidateSideBar />
                  {props.children}
                </div>
              </div>
            </section>
          </React.Fragment>
          <Footer />
        </>
      )}
    </>
  );
};
